import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext.jsx'

export default function LoginPage() {
  const { token, login } = useAuth()
  const nav = useNavigate()
  const loc = useLocation()
  const [pw, setPw] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)

  // Redirect when already authed — must run as an effect, not during render,
  // otherwise React warns "Cannot update a component while rendering another"
  // and the page flashes blank during the redirect.
  useEffect(() => {
    if (token) nav(loc.state?.from || '/', { replace: true })
  }, [token, loc.state, nav])

  if (token) return null

  const submit = async (e) => {
    e.preventDefault()
    setBusy(true); setErr(null)
    try {
      await login(pw)
      nav(loc.state?.from || '/', { replace: true })
    } catch (e) {
      setErr(e.message || 'Authentication failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-bg p-6">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-line bg-white p-8">
        <h1 className="mb-1 text-xl font-semibold tracking-tight">Clarity</h1>
        <p className="mb-6 text-sm text-muted">Mode démo — saisissez le mot de passe.</p>
        <input
          type="password"
          autoFocus
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="Mot de passe"
          className="mb-4 w-full rounded-lg border border-line bg-bg px-3 py-2 text-sm focus:border-terra-500 focus:outline-none"
        />
        {err && <p className="mb-3 text-xs text-terra-600">{err}</p>}
        <button
          type="submit"
          disabled={busy || !pw}
          className="w-full rounded-lg bg-ink py-2 text-sm font-medium text-white disabled:opacity-50"
        >
          {busy ? 'Connexion…' : 'Continuer'}
        </button>
      </form>
    </div>
  )
}
